import { Grid, Typography, Box, FormControlLabel, MenuItem } from '@material-ui/core';
import MROButton from 'components/buttons';
import YesNoField from 'components/form_components/YesNoField';
import React, { useContext, useEffect, useState } from 'react'
import useQuoteStyles from '../utils/QuoteStyles';
import UploadButton from "components/form_components/upload_multiple";
import PositiveSwitch from 'components/form_components/switch';
import lock from "assets/icons/Lock.svg";
import unlock from "assets/icons/Unlock.svg";
import { WorkshopContext } from '../../WorkshopContext/WorkshopContext';
import MROTextField from 'components/form_components/TextField';
import AwsDateFormat from "components/form_components/AwsDateFormat";
import QuantityCounter from "components/quantity_counter";
import AwsDateTimeFieldFor from "components/form_components/AwsDateTimeFieldFor";
import { ToastMessageContext } from 'lib/contexts/message_context';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import { getUserId } from 'lib/utils/common_utils';
import { validateFormData } from "lib/utils/helperFunctions";
export default function AcceptanceSection(props) {


    const {
        access,
        tabStatus,
        quoteStatus,
        loading,
        busy,
        errors,
        resetErrorsHandler,
        handlePopup,
        disabledAccptance,
        quotation,
        projectState,
        setErrors,
        setQty,
        qty,
        setDisabledAcceptance,
        editTab,
        setEditTab,
        tabId,
        setLoading,
        setBusy,
        getQuotation,
        getMaintenanceOrderList,
        updateAllPriceBreaks,
        disabled,
        quoteComments,
        handleClose,
        handleCloseTab,
        getWorkshopOrderDetails,
        action,
        setWorkshopOrderId
    } = props

    const [quoteAccept, setQuoteAccept] = useState(null);
    const [acceptanceAction, setAcceptanceAction] = useState(null);
    const [proofAcceptance, setProofAcceptance] = useState([]);
    const [customerOrderDoc, setCustomerOrderDoc] = useState([]);
    const [editStatus, setEditStatus] = useState(false);
    const classes = useQuoteStyles()
    const [fieldData, setFieldData] = useState(null);
    const {
        state,
        setState,
        shouldTabDataUpdate,
        setShouldTabDataUpdate,
        editButton,
        setEditButton,
        setTabStatus,
        setEditTabStatus,
    } = useContext(WorkshopContext);
    const [menu, setMenu] = useState(tabId === 20 ? "At Base - Goods In" : "At Base - NO Goods In");
    const [q_state, setQState] = useState(false)
    const [release, setRelease] = useState("At Base - Goods Out");
    const [switchState, setSwitchstate] = useState(false);
    const [commercialAccept, setCommercialAccept] = useState(null);
    const message = useContext(ToastMessageContext)

    let helperText = errors["accepted_quantity"] && (errors["quantity_is_zero"]
        ? "QTY Required Must Be Greater Than 0"
        : `Please enter Quantity required`)


    const handleInductionChange = (e) => {
        setMenu(e.target.value);
    };
    const handleReleaseChange = (e) => {
        setRelease(e.target.value);
    };

    const handleEditTab = () => {
        setEditButton(true);
        setDisabledAcceptance(!disabledAccptance);
        setEditTab(!editTab);
    };
    useEffect(() => {
        if (menu === "At Base - NO Goods In" || menu === "At Base - Goods In" || menu === "Away From Base") {
            setSwitchstate(false)
        }
    }, [menu])

    useEffect(() => {
        if (switchState === undefined || switchState === "") {
            setSwitchstate(false)
        }
    }, [switchState])


    const handleSaveForLater = () => {
        setAcceptanceAction("save_for_later");
    };



    // acceptance api 
    const handleAcceptanceOrderSubmit = async (e) => {
        e.preventDefault();
        setBusy("loading");
        updateAllPriceBreaks()
        setLoading(
            acceptanceAction === "save_for_later" ? "save_for_later" : "complete"
        );
        const formData = new FormData(e.target);
        const cus_order_num = formData.get("customer_order_number");
        // const customer_order_doc = formData.get("customer_order_doc[]");
        formData.append("automatic_commercial", commercialAccept === "yes" ? true : false)
        if (acceptanceAction === "save_for_later") {
            formData.delete("capture_later");
            formData.append(
                "capture_later",
                switchState === null ? false : switchState
            );
            formData.append("save_later", 1);
        }
        if (
            (acceptanceAction != "save_for_later" && quoteAccept === "yes") ||
            editTab
        ) {
            formData.delete("capture_later");
            const { error, valid } = validateFormData(formData, [
                "capture_later",
                "secondary_customer_ref",
                "automatic_commercial"
            ]);

            if (
                cus_order_num === "" &&
                cus_order_num.length === 0 &&
                !quotation?.customer_order_number?.length
            ) {
                setErrors((er) => ({ ...er, customer_order_number: true }));
                setLoading(null);
                setBusy(null);
            }
            if (
                (quotation?.customer_order_doc?.length === 0) &&
                customerOrderDoc.length === 0 &&
                switchState === false || switchState === undefined || switchState === "" &&
                !quotation?.customer_order_doc?.length
            ) {
                setErrors((er) => ({ ...er, "customer_order_doc[]": true }));
                setLoading(null);
                setBusy(null);
            }
            if (
                proofAcceptance.length === 0 &&
                !quotation?.proof_acceptance?.length
            ) {
                setLoading(null);
                setErrors((er) => ({ ...er, proof_acceptance: true }));
                setBusy(null);
            }

            if (
                (!valid && !disabled) ||
                (quotation?.customer_order_doc?.length === 0) &&
                (customerOrderDoc.length === 0 &&
                    switchState === false || switchState === undefined || switchState === "" &&
                    !quotation?.customer_order_doc?.length) ||
                (proofAcceptance.length === 0 &&
                    !quotation?.proof_acceptance?.length) ||
                (cus_order_num === "" &&
                    cus_order_num.length === 0 &&
                    !quotation?.customer_order_number?.length)
            ) {
                // console.log("captrue later goods in===", switchState)
                setErrors((err) => ({ ...err, ...error }));
                setLoading(null);
                setBusy(null);
                return;
            }

            if (!valid) {
                setBusy(null);
                setLoading(null);
                setErrors(error);
                return;
            }
        }
        if (quoteAccept === "yes" && acceptanceAction !== "save_for_later") {
            formData.delete("capture_later");
            formData.append(
                "capture_later",
                cus_order_num?.length ? false : switchState
            );
        }
        formData.delete("proof_acceptance");
        // formData.delete("automatic_commercial")

        const proof = [];
        proofAcceptance.forEach((_, i) => {
            proof[i] = Array.from(proofAcceptance[i]);
            proof[i].forEach((file) => formData.append("proof_acceptance", file));
        });
        formData.append("user_id", getUserId());
        formData.delete("customer_order_doc[]");
        formData.append("quote_comment", quoteComments);
        const cusOrder = [];
        customerOrderDoc.forEach((_, i) => {
            cusOrder[i] = Array.from(customerOrderDoc[i]);
            cusOrder[i].forEach((file) =>
                formData.append("customer_order_doc[]", file)
            );
        });

        if (editTab) {
            formData.append("close_tab", true);
            updateAllPriceBreaks()
            await MaintenanceServices.acceptanceOrder(formData, quotation?.id)
                .then((res) => {
                    setBusy(null);
                    if (res.success) {
                        // console.log("called edit tab inside");
                        setEditStatus(!editStatus);
                        setState((ps) => ({ ...ps, warningDialogState: false, isEditing: false }));
                        setEditButton(false);
                        handleCloseTab();
                        message.showToastMessage({
                            message: "Updated Successfully",
                            variant: "success",
                        });
                        setBusy(null);
                        setWorkshopOrderId(null)
                    }
                })
                .catch((res) => {
                    message.showToastMessage({
                        message: res?.errors ? res?.errors : "Something went wrong. Try again!",
                        variant: "error",
                    });
                    setBusy(null);
                    setWorkshopOrderId(null)
                });
        } else {

            await MaintenanceServices.acceptanceOrder(formData, quotation?.id)
                .then((res) => {
                    setLoading(null);
                    setBusy(null);
                    if (acceptanceAction === "save_for_later") {
                        message.showToastMessage({
                            message: "Saved Successfully",
                            variant: "success",
                        });
                        setTimeout(() => {
                            handleClose();
                            getMaintenanceOrderList();
                        }, 1000);
                        setState((ps) => ({ ...ps, warningDialogState: false, isEditing: false }));
                        setLoading(null);
                        setBusy(null);
                        setWorkshopOrderId(null)
                    } else {
                        message.showToastMessage({
                            message: "Updated Successfully",
                            variant: "success",
                        });
                        if (props?.tabState === 1 && props?.orderStateNum > 0) {
                            getQuotation();
                            getWorkshopOrderDetails();
                        } else {
                            setTimeout(() => {
                                handleClose();
                                getMaintenanceOrderList();
                            }, 1000);
                        }
                        setLoading(null);
                        setBusy(null);
                        setWorkshopOrderId(null)
                    }
                })
                .catch((err) => {
                    message.showToastMessage({
                        message: "Something went wrong. Try again!",
                        variant: "error",
                    });
                    setLoading(null);
                    setBusy(null);
                    setWorkshopOrderId(null)
                });
        }
        //creating planning id on complete


    };
    useEffect(() => {
        if (action === "Unlock") {

            setSwitchstate(quotation?.capture_later);
            setQty(quotation?.quantity);
            setQuoteAccept(
                quotation?.quote_accepted === true
                    ? "yes"
                    : quotation?.quote_accepted === false
                        ? "no"
                        : ""
            );
            setQState(quotation?.quote_accepted)
            setCommercialAccept(
                quotation?.automatic_commercial === true
                    ? "yes"
                    : quotation?.automatic_commercial === false
                        ? "no"
                        : ""
            );
            setFieldData(quotation?.quote_accepted_at);
            if (quotation?.induction_tab_style) { setMenu(quotation?.induction_tab_style) }
            if (quotation?.release_tab_style) { setRelease(quotation?.release_tab_style) }
        }
    }, [quotation]);








    return (
        <>

            <form noValidate onSubmit={handleAcceptanceOrderSubmit}>
                <Grid>
                    {quoteStatus && <Typography color="primary" style={{ marginBottom: "10px" }}>
                        Acceptance & Order Setup
                    </Typography>}
                    <Grid className={classes.paper}>
                        {quoteStatus && <>     <MROButton variant={"contained"}>Acceptance</MROButton>
                            <br />
                            <Grid
                                style={{ marginTop: "8px", background: "transparent" }}
                                className={access?.read ? classes.disableField : null}
                            >
                                <YesNoField
                                    disabled={!props.permission.write}
                                    label="Quote accepted? *"
                                    name="quote_accepted"
                                    handleToggle={(value) => {
                                        if (value) {
                                            setQuoteAccept(value);
                                            setQState(true)
                                        }

                                        handlePopup();
                                    }}
                                    value={quoteAccept}
                                    error={errors?.quote_accepted}
                                    setError={() => resetErrorsHandler("quote_accepted")}
                                />
                            </Grid></>}

                        {quoteAccept === "yes" && (
                            <Grid>
                                <Grid
                                    style={{ marginBottom: "20px" }}
                                    container
                                    spacing={5}
                                    alignItems={"center"}
                                    justify={"flex-start"}
                                >

                                    <Grid item xs={4}>
                                        <QuantityCounter
                                            name={"accepted_quantity"}
                                            label={"Accepted Quantity"}
                                            placeholder="QTY"
                                            disabled={disabledAccptance || projectState}
                                            required
                                            error={errors?.accepted_quantity}
                                            helperText={helperText}
                                            // helperText={
                                            //   errors["quantity"] &&
                                            //   (errors["quantity_is_zero"]
                                            //     ? "QTY Required Must Be Greater Than 0"
                                            //     : `Please enter Quantity required`)
                                            // }
                                            setError={() =>
                                                setErrors((prevState) => ({
                                                    ...prevState,
                                                    accepted_quantity: false,
                                                }))
                                            }
                                            setQty={setQty}
                                            qty={qty}
                                        />
                                    </Grid>


                                    <Grid className={classes.purchaseGrid} item xs={4}>
                                        <MROTextField
                                            name={"quote_accepted_by"}
                                            label={"Accepted by"}
                                            disabled={!props.permission.write}
                                            InputLabelProps={{ shrink: true }}
                                            placeholder={"Customer accepter name"}
                                            InputProps={{
                                                className: disabledAccptance && classes.disableField,
                                            }}
                                            required
                                            defaultValue={quotation?.quote_accepted_by}
                                            error={errors?.quote_accepted_by}
                                            onChange={(e) => {
                                                resetErrorsHandler(e.target.name);
                                                handlePopup();
                                            }}
                                        ></MROTextField>
                                    </Grid>
                                    <Grid className={classes.purchaseGrid} item xs={4}>
                                        <AwsDateTimeFieldFor
                                            required
                                            fullWidth
                                            pointerEvent={"none"}
                                            disabled={disabledAccptance || !props.permission.write}
                                            background={"#F5F5F5"}
                                            // format="ll - HH:mm"
                                            label={"Date / Time *"}
                                            format={"YYYY-MM-DD HH:mm:ss"}
                                            renderDate={"DD/MM/YYYY HH:mm"}
                                            placeholder="DD/MM/YYYY hh:mm"
                                            name="quote_accepted_at"
                                            value={fieldData}
                                            errors={errors?.quote_accepted_at}
                                            onChange={(e) => {
                                                resetErrorsHandler("quote_accepted_at");
                                                handlePopup();
                                            }}
                                            defaultValue={quotation?.quote_accepted_at}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                </Grid>

                                <Box
                                    display="flex"
                                    alignItems="center"
                                    margin="0 auto"
                                // style={{ display: access.read ? "none" : undefined }}
                                >
                                    <Box>
                                        <UploadButton
                                            readOnly={disabledAccptance || !props.permission.write}
                                            visibilityStatus={access.read ? "none" : undefined}
                                            multiple={false}
                                            accept={"multiple"}
                                            action={"Upload Document"}
                                            required={true}
                                            error={errors?.proof_acceptance}
                                            noFileExist={"Attached Files:"}
                                            defaultValue={quotation?.proof_acceptance?.map(
                                                (file) => ({
                                                    name: file.file_name,
                                                    url: file.path,
                                                })
                                            )}
                                            setFiles={(files) => {
                                                setProofAcceptance(files);
                                                resetErrorsHandler("proof_acceptance");
                                                handlePopup();
                                            }}
                                            name={"proof_acceptance"}
                                            label="Proof of acceptance *"
                                        />
                                    </Box>
                                </Box>

                                <Grid style={{ marginTop: 30 }}>
                                    <Typography color="primary" style={{ marginBottom: "10px" }}>
                                        Workshop Order Setup
                                    </Typography>
                                    <Grid
                                        style={{ marginBottom: "20px" }}
                                        container
                                        spacing={5}
                                        alignItems={"center"}
                                        justify={"flex-start"}
                                    >

                                        <Grid className={classes.purchaseGrid} item xs={4} style={{ marginTop: "3px" }}>
                                            <AwsDateFormat
                                                // required
                                                name={"planned_date"}
                                                type={"date"}
                                                label={"Planned Date *"}
                                                placeholder={"Date"}
                                                value={"DD/MM/YYYY"}
                                                disabled={disabledAccptance || !props.permission.write}
                                                defaultValue={quotation?.planned_date}
                                                formatProps={"YYYY-MM-DD HH:mm:ss"}
                                                InputLabelProps={{ shrink: true }}
                                                error={errors?.planned_date}
                                                onChange={(e, value) => {
                                                    resetErrorsHandler("planned_date");
                                                    handlePopup();
                                                }}
                                            />

                                        </Grid>

                                        <Grid className={classes.purchaseGrid} item xs={4}>
                                            <MROTextField
                                                name={"induction_tab_style"}
                                                label={"Induction Tab Style"}
                                                placeholder={"Select"}
                                                disabled={!props.permission.write}
                                                value={menu}
                                                select
                                                required
                                                InputProps={{
                                                    className: disabledAccptance && classes.disableField,
                                                }}
                                                // defaultValue={"At Base - Goods In"}
                                                InputLabelProps={{ shrink: true }}
                                                error={errors?.induction_tab_style}
                                                onChange={(e) => {
                                                    resetErrorsHandler(e.target.name);
                                                    handleInductionChange(e);
                                                    handlePopup();
                                                }}
                                            >
                                                <MenuItem value={"At Base - Goods In"}>
                                                    At Base - Goods In
                                                </MenuItem>
                                                <MenuItem value={"At Base - NO Goods In"}>
                                                    At Base - NO Goods In
                                                </MenuItem>
                                                <MenuItem value={"Away From Base"}>
                                                    Away From Base
                                                </MenuItem>
                                            </MROTextField>
                                        </Grid>

                                        <Grid className={classes.purchaseGrid} item xs={4}>
                                            <MROTextField
                                                name={"release_tab_style"}
                                                label={"Release Tab Style *"}
                                                placeholder={"Select"}
                                                disabled={!props.permission.write}
                                                value={release}
                                                select
                                                InputProps={{
                                                    className: disabledAccptance && classes.disableField,
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                // defaultValue={quotation?.release_tab_style}
                                                error={errors?.release_tab_style}
                                                onChange={(e) => {
                                                    resetErrorsHandler(e.target.name);
                                                    handleReleaseChange(e);
                                                    handlePopup();
                                                }}
                                            >
                                                <MenuItem value={"At Base - Goods Out"}>
                                                    At Base - Goods Out
                                                </MenuItem>
                                                <MenuItem value={"At Base - NO Goods Out"}>
                                                    At Base - NO Goods Out
                                                </MenuItem>
                                                <MenuItem value={"Away From Base"}>
                                                    Away From Base
                                                </MenuItem>
                                                <MenuItem value={"Stock Receipt"}>
                                                    Stock Receipt
                                                </MenuItem>
                                                {/* <MenuItem value={"Scrap"}>
                          Scrap
                        </MenuItem> */}
                                            </MROTextField>
                                        </Grid>



                                    </Grid>


                                    <Grid item xs={5} style={{ marginTop: "2px", background: "transparent" }}
                                        className={access.read ? classes.disableField : null}
                                    >
                                        <YesNoField
                                            disabled={!props.permission.write}
                                            label="Automatic Commercial Approval?"
                                            name="automatic_commercial"
                                            handleToggle={(value) => {
                                                if (value) {
                                                    setCommercialAccept(value);
                                                }
                                                handlePopup();
                                            }}
                                            value={commercialAccept}

                                        /></Grid>





                                </Grid>

                                <Grid style={{ marginTop: 10 }}>
                                    <Typography color="primary" style={{ marginBottom: "10px" }}>
                                        Customer Order
                                    </Typography>

                                    <div>
                                        <FormControlLabel
                                            control={
                                                <PositiveSwitch
                                                    disabled={!props.permission.write || disabledAccptance || menu === "At Base - NO Goods In" || menu === "Away From Base"}
                                                    defaultChecked={quotation?.capture_later}
                                                    // className={access.read ? classes.disableField : null}
                                                    checked={switchState}
                                                    // value={switchState}
                                                    // InputProps={{
                                                    //   className:
                                                    //     disabledAccptance && classes.disableField,
                                                    // }}
                                                    name="capture_later"
                                                    onChange={(e) => {
                                                        setSwitchstate(e.target.checked);
                                                        handlePopup();
                                                    }}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    variant="body2"
                                                    style={{ marginTop: "5px", marginLeft: "0px" }}
                                                >
                                                    Capture later at Goods in ?
                                                </Typography>
                                            }
                                            labelPlacement="start"
                                            name={"capture_later"}
                                        />
                                    </div>

                                    {!switchState ? (
                                        <Grid>
                                            <Grid
                                                style={{ marginBottom: "20px" }}
                                                container
                                                spacing={5}
                                                alignItems={"center"}
                                                justify={"flex-start"}
                                            >
                                                <Grid className={classes.purchaseGrid} item xs={4}>
                                                    <MROTextField
                                                        name={"customer_order_number"}
                                                        label={"Customer Order # *"}
                                                        placeholder={"Purchase Order, or Service Order ref"}
                                                        disabled={!props.permission.write}
                                                        InputProps={{
                                                            className:
                                                                disabledAccptance && classes.disableField,
                                                        }}
                                                        inputProps={{ maxLength: 30 }}
                                                        InputLabelProps={{ shrink: true }}
                                                        defaultValue={quotation?.customer_order_number}
                                                        error={errors?.customer_order_number}
                                                        onChange={(e) => {
                                                            resetErrorsHandler(e.target.name);
                                                            handlePopup();
                                                        }}
                                                    ></MROTextField>
                                                </Grid>
                                                <Grid className={classes.purchaseGrid} item xs={4}>
                                                    <MROTextField
                                                        name={"secondary_customer_ref"}
                                                        label={"Secondary Customer Ref"}
                                                        disabled={!props.permission.write}
                                                        placeholder={"Aircraft Reg, or other customer ref"}
                                                        inputProps={{ maxLength: 30 }}
                                                        InputProps={{
                                                            className:
                                                                disabledAccptance && classes.disableField,
                                                        }}
                                                        defaultValue={quotation?.secondary_customer_ref}
                                                        onChange={(e) => {
                                                            handlePopup();
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                    ></MROTextField>
                                                </Grid>
                                            </Grid>

                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                margin="0 auto"
                                            // style={{ display: access.read ? "none" : undefined }}
                                            >
                                                <UploadButton
                                                    readOnly={disabledAccptance || !props.permission.write}
                                                    visibilityStatus={access.read ? "none" : undefined}
                                                    multiple={true}
                                                    accept={"multiple"}
                                                    action={"Upload Document"}
                                                    noFileExist={"Attached Files:"}
                                                    defaultValue={quotation?.customer_order_doc?.map(
                                                        (file) => ({
                                                            name: file.file_name,
                                                            url: file.path,
                                                        })
                                                    )}
                                                    error={errors["customer_order_doc[]"]}
                                                    setFiles={(files) => {
                                                        setCustomerOrderDoc(files);
                                                        resetErrorsHandler("customer_order_doc[]");
                                                        handlePopup();
                                                    }}
                                                    name={"customer_order_doc[]"}
                                                    label="Customer Order Doc *"
                                                />
                                            </Box>
                                        </Grid>
                                    ) : (
                                        ""
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        {props?.orderStateNum === 0 && props?.tabState === 1 && props?.permission.write && q_state && (
                            <Grid item md={12} style={{ marginTop: "15px" }}>
                                <div className={"align-right"}>
                                    <MROButton
                                        disabled={
                                            quoteStatus === false ||
                                            quoteStatus === undefined ||
                                            quoteStatus === null
                                        }
                                        loading={loading === "save_for_later"}
                                        style={{
                                            marginRight: "15px",
                                            display: access.read ? "none" : undefined,
                                        }}
                                        variant={"contained"}
                                        type="submit"
                                        onClick={() => handleSaveForLater()}
                                    >
                                        Save for later
                                    </MROButton>
                                    <MROButton
                                        disabled={
                                            quoteStatus === false ||
                                            quoteStatus === undefined ||
                                            quoteStatus === null
                                        }
                                        variant={"contained"}
                                        loading={loading === "complete"}
                                        type="submit"
                                        color="primary"
                                        style={{ display: access.read ? "none" : undefined }}
                                        onClick={() => setAcceptanceAction("complete")}
                                    >
                                        Complete
                                    </MROButton>
                                </div>
                            </Grid>
                        )}
                    </Grid>

                    <div className={"align-right"}>
                        {quoteAccept === "yes" &&
                            tabStatus &&
                            props?.orderStateNum > 0 &&
                            props?.orderStateNum <= 8 && props.permission.write && (
                                <MROButton
                                    type="button"
                                    variant={"contained"}
                                    style={{
                                        backgroundColor: "#FFB000",
                                        color: "white",
                                        display: editTab ? "none" : undefined,
                                        marginTop: "18px",
                                    }}
                                    onClick={() => {
                                        handleEditTab();
                                        setEditStatus(!editStatus);
                                        setEditTabStatus(true)
                                        setState((ps) => ({ ...ps, warningDialogState: false, isEditing: false, shouldShowWarning: false, editTabStatus: true }));
                                    }}
                                    startIcon={
                                        <img className={classes.svg} src={lock} alt="lock" />
                                    }
                                >
                                    Edit Tab
                                </MROButton>
                            )}

                        {props?.tabState === 1 && props?.orderStateNum > 0 && props?.permission.write && (
                            <MROButton
                                variant={"contained"}
                                style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    marginTop: "18px",
                                }}
                                type={state.warningState ? "button" : "submit"}
                                loading={busy === "loading"}
                                onClick={() => {
                                    state.warningState &&
                                        message.showToastMessage({
                                            message: " Quote must be sent first!!",
                                            variant: "error",
                                        });
                                }}
                                startIcon={
                                    <img className={classes.svg} src={unlock} alt="unlock" />
                                }
                            >
                                Close Tab
                            </MROButton>
                        )}
                    </div>
                </Grid>
            </form>







        </>
    )
}
